import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { AmUserType, AmUserSearch } from './amUserApiTypes';

export const getAmUser = async (config: LoruleRequestConfig, personId: number) =>
    callWebUtils<AmUserType>(config, `/user/${personId}`, 'GET', null, commonHeaders);

export const getAllAmUsers = async (config: LoruleRequestConfig, name?: string) =>
    callWebUtils<Array<AmUserType>>(
        config,
        `/user${name ? `?name=${encodeURIComponent(name)}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );

export const getAmUsers = async (config: LoruleRequestConfig, search?: AmUserSearch | null) => {
    let queryString = '';
    if (search) {
        const { name, amCreator, projectManager, approver } = search;
        if (name) queryString += `&name=${name}`;
        if (amCreator !== null && amCreator !== undefined) queryString += `&amCreator=${amCreator}`;
        if (projectManager !== null && projectManager !== undefined)
            queryString += `&projectManager=${projectManager}`;
        if (approver !== null && approver !== undefined) queryString += `&approver=${approver}`;
    }
    return callWebUtils<Array<AmUserType>>(
        config,
        `/user?current=true${queryString}`,
        'GET',
        null,
        commonHeaders,
    );
};

export const getContractSignerUsers = async (config: LoruleRequestConfig, name?: string) =>
    callWebUtils<Array<AmUserType>>(
        config,
        `/user?contractSigner=true${name ? `&name=${encodeURIComponent(name)}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );
